import React, { SyntheticEvent } from "react";
import cn from "classnames";
import { Loader, Tooltip, Whisper, WhisperProps } from "rsuite";

import ReloadIcon from "@rsuite/icons/Reload";

import "./RefreshButton.less";

interface Props {
    disabled?: boolean;
    loading?: boolean;
    tooltip?: string;
    tooltipPlacement?: WhisperProps["placement"];
    onClick: () => void;
}

const RefreshButton: React.FC<Props> = ({
    disabled = false,
    loading = false,
    tooltip,
    tooltipPlacement = "top",
    onClick,
}: Props) => {
    const handleClick = (event: SyntheticEvent) => {
        event.stopPropagation();
        onClick();
    };

    if (loading) {
        return (
            <span className={"refresh-button"}>
                <Loader size="xs" />
            </span>
        );
    }

    const button = (
        <span
            className={cn("refresh-button", {
                "refresh-button--disabled": disabled,
            })}
            onClick={handleClick}
        >
            <ReloadIcon className={"refresh-button__icon"} />
        </span>
    );

    if (!tooltip) {
        return button;
    }

    return (
        <Whisper
            trigger={"hover"}
            placement={tooltipPlacement}
            speaker={<Tooltip>{tooltip}</Tooltip>}
        >
            {button}
        </Whisper>
    );
};

export default RefreshButton;
